import { isExcludedFromAdministrationNav } from '@/config/moduleDefaults';
import { isSettingsLegacyRoute } from '@/config/settingsRegistry';

/** Routes registered for screen actions but omitted from sidebar / command palette menus. */
export const NAV_HIDDEN_ROUTES = new Set([
  '/hr/leave-policies',
  '/hr/documents',
  '/hr/leaves',
]);

/** Sidebar sections replaced by Settings or Work — omit from module nav. */
export const SIDEBAR_HIDDEN_GROUP_IDS = new Set(['administration', 'setup']);

/** Module workflow designer URLs — use Work → Workflow builder instead. */
const MODULE_WORKFLOW_NAV_PATHS = new Set([
  '/hr/workflows',
  '/social/workflows',
  '/finance/workflows',
  '/finance/workflows/designer',
  '/desk/setup/workflows',
]);

export function isModuleWorkflowNavRoute(path: string): boolean {
  const normalized = path.split('?')[0].replace(/\/+$/, '') || '/';
  return MODULE_WORKFLOW_NAV_PATHS.has(normalized);
}

export function isNavHiddenRoute(path: string): boolean {
  const normalized = path.split('?')[0].replace(/\/+$/, '') || '/';
  return (
    NAV_HIDDEN_ROUTES.has(normalized) ||
    isExcludedFromAdministrationNav(normalized) ||
    isSettingsLegacyRoute(normalized) ||
    isModuleWorkflowNavRoute(normalized)
  );
}

export function filterHiddenNavItems<T extends { route?: string; to?: string }>(items: T[]): T[] {
  return items.filter((item) => {
    const path = (item.route ?? item.to ?? '').split('?')[0];
    return !isNavHiddenRoute(path);
  });
}
